/**
 * Session duration preference helpers.
 *
 * Default 30 days; clamp to Stytch's documented [5, 527040] range.
 */

export const DEFAULT_SESSION_DURATION_MINUTES = 43200;
export const MIN_SESSION_DURATION_MINUTES = 5;
export const MAX_SESSION_DURATION_MINUTES = 527040;

export function clampSessionDurationMinutes(value: unknown): number {
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return DEFAULT_SESSION_DURATION_MINUTES;
  }
  const rounded = Math.round(value);
  if (rounded < MIN_SESSION_DURATION_MINUTES) return MIN_SESSION_DURATION_MINUTES;
  if (rounded > MAX_SESSION_DURATION_MINUTES) return MAX_SESSION_DURATION_MINUTES;
  return rounded;
}

export function readSessionDurationMinutes(
  preferences: { session_duration_minutes?: number } | null | undefined,
): number {
  return clampSessionDurationMinutes(preferences?.session_duration_minutes);
}
